import type { PaginatedV3SearchTrades } from 'lib/sdks/search';
import * as TYPES from './constants';

export const getSearchResultsInit = (payload: any) => ({
  type: TYPES.GET_SEARCH_RESULTS_INIT,
  payload,
});

export const getSearchResultsSuccess = (payload: {
  data: PaginatedV3SearchTrades;
  key: number;
}) => ({
  type: TYPES.GET_SEARCH_RESULTS_SUCCESS,
  payload,
});

export const getSearchResultsError = (payload: any) => ({
  type: TYPES.GET_SEARCH_RESULTS_ERROR,
  payload,
});

export const storeSearchMeta = (payload: any) => ({
  type: TYPES.STORE_SEARCH_META,
  payload,
});

export const getMoreTradesResultsInit = (payload: any) => ({
  type: TYPES.GET_MORE_TRADES_RESULTS_INIT,
  payload,
});

export const getMoreTradesResultsSuccess = (payload: any) => ({
  type: TYPES.GET_MORE_TRADES_RESULTS_SUCCESS,
  payload,
});

export const sortSearchResults = (payload: {
  categorySlug: string;
  location: string;
  algorithm: string;
  deviceId: string;
}) => ({
  type: TYPES.SORT_SEARCH_RESULTS,
  payload,
});

export const sortSearchResultsSucess = (payload: {
  data: PaginatedV3SearchTrades;
  key: number;
}) => ({
  type: TYPES.SORT_SEARCH_RESULTS_SUCCESS,
  payload,
});
